"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQualtricsLocaleCode = exports.getTranslations = void 0;
const translations_1 = __importDefault(require("../i18n/translations"));
function getTranslations(locale) {
    return translations_1.default[locale];
}
exports.getTranslations = getTranslations;
// Returns the locale code used in Qualtrics (May need to be updated if more locales are supported)
function getQualtricsLocaleCode(locale) {
    if (locale === 'en_US') {
        return 'EN';
    }
    const [language, country] = locale.toUpperCase().split('_');
    return country === undefined || country === language ? language : `${language}-${country}`;
}
exports.getQualtricsLocaleCode = getQualtricsLocaleCode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaTE4bkhlbHBlcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvaTE4bkhlbHBlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsd0VBQWdEO0FBU2hELFNBQWdCLGVBQWUsQ0FBQyxNQUFjO0lBQzFDLE9BQU8sc0JBQVksQ0FBQyxNQUFNLENBQUMsQ0FBQztBQUNoQyxDQUFDO0FBRkQsMENBRUM7QUFFRCxtR0FBbUc7QUFDbkcsU0FBZ0Isc0JBQXNCLENBQUMsTUFBYztJQUNqRCxJQUFJLE1BQU0sS0FBSyxPQUFPLEVBQUU7UUFDcEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUVELE1BQU0sQ0FBQyxRQUFRLEVBQUUsT0FBTyxDQUFDLEdBQUcsTUFBTSxDQUFDLFdBQVcsRUFBRSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUU1RCxPQUFPLE9BQU8sS0FBSyxTQUFTLElBQUksT0FBTyxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxHQUFHLFFBQVEsSUFBSSxPQUFPLEVBQUUsQ0FBQztBQUMvRixDQUFDO0FBUkQsd0RBUUMifQ==